module.exports = __webpack_public_path__ + "static/img/qq.9bbb74af.png";